<template>
  <v-tooltip bottom v-if="!!pgLink">
    <template v-slot:activator="{ on, attrs }">
      <a :class="boundaryClass" v-bind="attrs" v-on="on">
        <VBtn color="primary" outlined class="pgBtn" @click="copyToClipBoard()">
          {{ label }}
          <div class="icon">
            <v-icon x-small color="primary">mdi-content-copy</v-icon>
          </div>
        </VBtn>
      </a>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>

  <div v-else>--</div>
</template>

<script lang="ts">
import Helper from "@/util/Helper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { VBtn } from "vuetify/lib";
import FCopy from "../../FCopyBtn.vue";
import ModelVue from "../../ModelVue";

@Component({
  components: { VBtn, FCopy },
})
export default class FCellBtnLink extends ModelVue {
  @Prop()
  onClick: (item: any) => void;

  @Prop({
    default: "green",
  })
  color: string;

  @Prop()
  icon: string;

  @Prop()
  dataSelectorKey: string;

  @Prop()
  label: string;

  get pgLink() {
    return this.selectModel(this.modelValue, this.dataSelectorKey);
  }

  copyToClipBoard() {
    Helper.copyToClipBoard(this.pgLink);
  }
}
</script>

<style scoped>
.pgBtn {
  font-size: 10px;
  height: 20px !important;
  justify-content: space-between;
  display: flex;
  padding: 0 10px !important;
  font-weight: bold;
}
.textColor {
  color: #fff;
}
.icon {
  margin-left: 5px;
}
</style>
